import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssButtonPage extends ComponentBase {

    protected iconOptions: Array<string> = ['ui:icons.alert', 'ui:icons.assessment', 'ui:icons.city'];
    protected typeOptions: Array<string> = ['add', 'copy', 'save', 'download'];
    protected tooltipPositionOptions: Array<string> = ['bottom', 'top', 'left', 'right'];
    protected options: Array<string> = ['option 1', 'option 2', 'option 3', 'option 4', 'option 5', 'option 6'];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.getUiOptions();
    }

    ////****************** Example 1 ********************************************////
    protected ex1Value: number = 0;

    protected ex1ButtonClick(): void {
        this.ex1Value++;
    }

    ////****************** Example 2 ********************************************////
    protected ex2Text: string | null = '';
    protected ex2Type: string | null = this.typeOptions[0];
    protected ex2What: string | null = 'cd:memberContact.address.alternate.$ | t';

    protected ex2ButtonClick(option: string): void {
        this.ex2Text = option;
    }

    ////****************** Example 3 ********************************************////
    protected ex3DescribedById: string | null = 'demo-id';
    protected ex3DescribedByIdText: string | null = 'Demo text';
    protected ex3Text: string | null = '';
    protected ex3Type: string | null = null;
    protected ex3CustomText: string | null = 'Custom Text Without Type';
    protected ex3Tooltip: string | null = 'My tooltip';
    protected ex3TooltipPosition: string | null = this.tooltipPositionOptions[0];
    protected ex3Dropdown: boolean = false;
    protected ex3DescribedByIcon: boolean = true;

    protected ex3ButtonClick(option: string): void {
        this.ex3Text = option;
    }

    ////****************** Functions ************************************************////
    protected async getUiOptions(): Promise<void> {
        const uiJson = await fetch('/locales/en/ui.json').then(response => response.json());

        if(uiJson.actions) {
            this.typeOptions = Object.keys(uiJson.actions);
        }

        if(uiJson.icons) {
            this.iconOptions = Object.keys(uiJson.icons).map(objectKey => `ui:icons.${objectKey}`);
        }
    }
}
